import React from 'react';
import PropTypes from 'prop-types';

/**
 * Renders a child or children if any of the `names` are contained in `available`
 *
 * Common use case: An api endpoint tells the front end which fields to display
 *   By wrapping a field in <AvailableField> and feeding in the name and available names
 *   the backend can effectively decide which fields to show and which to hide
 *
 * @example
 * <AvailableField name={['first_name]} available={['first_name', 'last_name']}>
 *   <span>this is rendered as first_name is available</span>
 * </AvailableField>
 *
 * <AvailableField name={['middle_name]} available={['first_name', 'last_name']}>
 *   <span>this is not rendered as middle_name is not available</span>
 * </AvailableField>
 */
export default class AvailableField extends React.Component {
  static propTypes = {
    names: PropTypes.arrayOf(PropTypes.string),
    available: PropTypes.arrayOf(PropTypes.string),
    children: PropTypes.arrayOf(PropTypes.node)
  }

  render() {
    return this.props.available && this.props.names.every(e => this.props.available.includes(e)) ? this.props.children : null;
  }
}
